import Dict2 from './Dict'
import { mergeOptions } from './DictOptions'

export default function(Vue, options) {
  mergeOptions(options)
  Vue.mixin({
    data() {
      if (this.$options.dicts2 === undefined || this.$options.dicts2 === null) {
        return {}
      }
      const dict2 = new Dict2()
      dict2.owner = this
      return {
        dict2
      }
    },
    created() {
      if (!(this.dict2 instanceof Dict2)) {
        return
      }
      options.onCreated && options.onCreated(this.dict2)
      this.dict2.init(this.$options.dicts2).then(() => {
        options.onReady && options.onReady(this.dict2)
        this.$nextTick(() => {
          this.$emit('dictReady', this.dict2)
          if (this.$options.methods && this.$options.methods.onDictReady instanceof Function) {
            this.$options.methods.onDictReady.call(this, this.dict2)
          }
        })
      })
    },
  })
}
